import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../shared/toast';
import { AutenticacaoService } from './autenticacao.service';

const HTTP_ERRORS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptService implements HttpInterceptor {

  constructor(
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private toastService: ToastService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const isUserAuthenticated = this.autenticacaoService.temColaboradorAutenticado() || this.autenticacaoService.token;
          const isTokenExpiredStatus = error.status === HTTP_ERRORS.UNAUTHORIZED || error.status === HTTP_ERRORS.FORBIDDEN;
          if (isUserAuthenticated && isTokenExpiredStatus) {
            this.autenticacaoService.logout();
            this.router.navigate(['']);
            this.toastService.show({ title: 'Atenção', text: 'Seu tempo de sessão expirou. Por favor, faça login novamente para continuar.', type: 'error' });
            return;
          }
          return throwError(error);
        })
      );
  }
}
